import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { DBEngineType, StorageManager } from '@tencent/ark-storage';
import { DriveDataApi } from "./drive-data-api";
import { isSupportClientDB } from "./utils";
export var DriveDataApiManager = /*#__PURE__*/function () {
  function DriveDataApiManager() {
    _classCallCheck(this, DriveDataApiManager);
    _defineProperty(this, "driveDataApi", void 0);
  }
  _createClass(DriveDataApiManager, [{
    key: "getDriveDataApi",
    value: function getDriveDataApi() {
      if (!this.driveDataApi) {
        var storageManager = new StorageManager({
          type: isSupportClientDB() ? DBEngineType.nativeDB : DBEngineType.indexDB,
          disableAutoOpen: false
        });
        this.driveDataApi = new DriveDataApi(storageManager, console);
      }
      return this.driveDataApi;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new DriveDataApiManager();
      }
      return this.instance;
    }
  }]);
  return DriveDataApiManager;
}();
_defineProperty(DriveDataApiManager, "instance", void 0);
//# sourceMappingURL=drive-data-api-manager.js.map